/**
 * 
 * key
 * 
 */


const key = 'Y3JtV2lzZUZvbGxvd3VwVHlwZVJlcG9ydA=='

export default key 